import { Link } from 'react-router-dom';
import { cn } from '../../lib/cn';
import { Picture } from '../ui/Picture';
import styles from './Logo.module.css';

/**
 * The "np" mark is the brand asset extracted from the Figma file — it was
 * sitting in the comp under a layer named "header", not as a logo layer.
 */
export function Logo({ to = '/', size = 34, className }) {
  return (
    <Link to={to} className={cn(styles.logo, className)} aria-label="NimblePark — home">
      <Picture
        name="logo-mark"
        alt=""
        fit="contain"
        sizes={`${size}px`}
        priority
        className={styles.mark}
        style={{ width: size, height: size, aspectRatio: '1 / 1' }}
      />
      <span className={styles.word} style={{ fontSize: size * 0.62 }}>
        NimblePark
      </span>
    </Link>
  );
}
